import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GettingStarted.css';

const STEPS = [
  {
    id: 'read_rules',
    label: 'Check the rules',
    sub: 'read about dmyor terminology and how it works',
    action: '/blog/the-rules-how-dmyor-actually-works',
    actionLabel: 'Read',
  },
  {
    id: 'create_vision',
    label: 'Create your first Vision',
    sub: 'Define what you want to achieve this year',
    action: '/dashboard/year-plans',
  },
  {
    id: 'add_node',
    label: 'Add a record to your Vision',
    sub: 'Break your vision into meaningful goals',
    action: null,
  },
  {
    id: 'add_update',
    label: 'Write your first update',
    sub: 'Log progress on a record to keep momentum',
    action: null,
  },
  {
    id: 'dmyor_assist',
    label: 'Try Dmyor Assist',
    sub: 'Get AI backed guidance and discussion on your record',
    action: null,
  },
  {
    id: 'space_view',
    label: 'Explore the Space View',
    sub: 'See your whole vision at a glance',
    action: null,
  },
  {
    id: 'analysis',
    label: 'Get an AI analysis report',
    sub: 'Deep dive into your progress on a record',
    action: null,
  },
];

export const STEPS_IDS = STEPS.map(s => s.id);

const GettingStarted = ({ completed, onToggle }) => {
  const navigate = useNavigate();
  const doneCount = completed.size;
  const pct = Math.round((doneCount / STEPS.length) * 100);

  return (
    <div className="gs-wrap">
      <p className="gs-eyebrow">Getting started</p>
      <h2 className="gs-heading">Welcome to Dmyor</h2>

      <div className="gs-progress-row">
        <div className="gs-progress-track">
          <div className="gs-progress-fill" style={{ width: `${pct}%` }} />
        </div>
        <span className="gs-progress-label">{doneCount} / {STEPS.length}</span>
      </div>

      <div className="gs-journey">
        {STEPS.map((step, i) => {
          const done = completed.has(step.id);
          const isLast = i === STEPS.length - 1;

          return (
            <div key={step.id} className="gs-step-row">
              {/* Left: connector line + node */}
              <div className="gs-connector-col">
                <button
                  className={`gs-node ${done ? 'gs-node-done' : ''}`}
                  onClick={() => onToggle(step.id)}
                  aria-label={done ? 'Mark incomplete' : 'Mark complete'}
                >
                  {done ? <span className="gs-check-icon">✓</span> : <span className="gs-node-num">{i + 1}</span>}
                </button>
                {!isLast && <div className={`gs-line ${done ? 'gs-line-done' : ''}`} />}
              </div>

              {/* Right: card */}
              <div className={`gs-card ${done ? 'gs-card-done' : ''}`}>
                <div className="gs-card-body">
                  <p className="gs-card-label">{step.label}</p>
                  <p className="gs-card-sub">{step.sub}</p>
                </div>
                {!done && step.action && (
                  <button className="gs-item-btn" onClick={() => navigate(step.action)}>
                    {step.actionLabel || 'Start'}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GettingStarted;
